// extracted by mini-css-extract-plugin
module.exports = {"container":"pt","brandName":"qt","productName":"rt"};